import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

interface VideoModalProps {
  onClose: () => void;
  shouldShow: boolean;
  url: string;
  type: string;
}

export default function VideoModal({ onClose, shouldShow, type, url }: VideoModalProps) {
  const [time, setTime] = useState<number>(5);
  const [intervalIds, setIntervalIds] = useState<NodeJS.Timeout[]>([]);

  useEffect(() => {
    // if (type == "image") {
    //   setTimeout(() => onClose(), 5000);
    // }
  }, [type]);

  useEffect(() => {
    if (time == 0) {
      onClose();
      //   return;
    }
    const id = setInterval(() => {
      setTime(time - 1);
    }, 1000);
    const x = intervalIds?.length ? [...intervalIds] : [];
    x.push(id);
    setIntervalIds(x);
    // console.log({ id });
    return () => {
      const y = [...intervalIds];
      //   console.log({ y });
      y.forEach((i) => clearInterval(i));
    };
  }, [time]);

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body bsPrefix={"main-container"}>
          <div className="modal-body">
            {type == "image" && <h2>Promo image closes in {time} seconds...</h2>}
            {type == "video" ? (
              <video
                id="promoVid"
                src={url}
                preload="auto"
                autoPlay={true}
                muted={true}
                width="100%"
                height="100%"
                onEnded={() => onClose()}
              ></video>
            ) : (
              <img src={url} style={{ width: "100%" }} />
            )}
          </div>
        </Modal.Body>
        {type == "image" && (
          <Modal.Footer>
            <div className="btn-wrap mb-3 ">
              <button
                type="button"
                className="rkmd-btn btn-lg btn-black ripple-effect w-100 mt-3"
                onClick={() => onClose()}
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </React.Fragment>
  );
}
